import { Theme } from '@mui/material';

export const styles = (theme: Theme) => {
  return {
    toastContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: theme.custom.gap.medium,
      borderRadius: theme.custom.borderRadius.large,
      width: `max(80vh, 54rem)`,
    },
    loaderBtnBox: {
      display: 'flex',
      alignItems: 'center',
      justifyContet: 'space-between',
      gap: theme.custom.gap.medium,
    },
    iconAndTextBox: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.custom.gap.xSmall,
    },
    messageStyles: {
      color: 'background.default',
      fontSize: theme.typography.textSize['0_875'],
      fontWeight: theme.typography.fontWeight.medium,
    },
  };
};
